import * as appActions from '@src/state/app/actions'
import { appInitialized } from '@src/state/app/actions'
import { GlobalActions } from '@src/types/actions'
import { ActionType, getType } from 'typesafe-actions'
import { resetState } from '../actions'

export interface AppState {
  initialized: boolean
}

const initialState: AppState = {
  initialized: false,
}

type AppActions = ActionType<typeof appActions>

const appStateReducer = (
  state: AppState = initialState,
  action: AppActions | GlobalActions
) => {
  switch (action.type) {
    case getType(appInitialized): {
      return {
        ...state,
        initialized: true,
      }
    }
    case getType(resetState): {
      return initialState
    }
    default:
      return state
  }
}

export default appStateReducer



// WEBPACK FOOTER //
// ./src/state/app/reducer.ts